import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsSearchModalProps = {
  nwtPage?: string;
};

export type SearchAlertsSearchModalXinglet =
  XingletInterface<SearchAlertsSearchModalProps>;

export const SearchAlertsSearchModal =
  JobsXingletWrapper<SearchAlertsSearchModalProps>(
    '@xing-com/crate-jobs-domain-search-alerts-search-modal'
  );
